// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Disclaimer_wrapper__3HGoP","action":"Disclaimer_action__3uxXt","container":"Disclaimer_container__39FuE"};